import { useRequest } from '@umijs/max';

import { getTranslations } from './index';

export const useGetTranslations = () => useRequest(getTranslations, {
  cacheKey: 'getTranslations',
  staleTime: Infinity,
});
